export interface KlsVersionFiledsInterface {
  title: string;
  field: string;
}
export interface KlsVersionInfoFiledsInterface {
  title: string;
  children: Array<KlsVersionFiledsInterface>;
}
export const klsVersionInfoFileds: Array<KlsVersionInfoFiledsInterface> = [
  {
    title: "控制器版本",
    children: [
      { title: "软件版本号", field: "aebsSwVersion" },
      { title: "SN序列号", field: "aebsSn" },
      { title: "PN序列号", field: "aebsPn" },
    ],
  },
  {
    title: "双目相机版本",
    children: [
      { title: "软件版本号", field: "cameraSwVersion" },
      { title: "双目相机硬件版本号", field: "cameraHwVersion" },
      { title: "SN序列号", field: "cameraSn" },
      { title: "PN序列号", field: "cameraPn" },
    ],
  },
  {
    title: "显示屏版本",
    children: [
      { title: "软件版本号", field: "displayerSwVersion" },
      { title: "SN序列号", field: "displayerSn" },
      { title: "PN序列号", field: "displayerPn" },
    ],
  },
  {
    title: "雷达版本",
    children: [
      { title: "超声波雷达版本号", field: "uradarVersion" },
      { title: "毫米波雷达版本号", field: "mradarVersion" },
    ],
  },
  {
    title: "通信协议版本",
    children: [
      { title: "相机CAN协议版本号", field: "cameraCanProtocoiVersion" },
      { title: "PC端串口协议版本号", field: "aebsAtPcProtocoiVersion" },
      { title: "蓝牙串口协议版本号", field: "aebsAtBtProtocoiVersion" },
      { title: "控制器CAN协议版本号", field: "aebsCanProtocoiVersion" },
      { title: "显示器CAN协议版本号", field: "displayerCanProtocoiVersion" },
      { title: "云平台协议版本号", field: "cloudPlatformProtocoiVersion" },
    ],
  },
  {
    title: "记录仪版本",
    children: [
      { title: "软件版本号", field: "carDvrVersion" },
      { title: "SN序列号", field: "carDvrSn" },
    ],
  },
];

export const lxVersionINfoFileds: Array<KlsVersionInfoFiledsInterface> = [
  {
    title: "领行",
    children: [
      { title: "Uboot版本号", field: "ubootVersion" },
      { title: "Kernel版本号", field: "kernelVersion" },
      { title: "文件系统版本号", field: "fileSystemVersion" },
      { title: "控制器软件版本号", field: "aebsSwVersion" },
      { title: "控制器硬件版本号", field: "aebsHwVersion" },
      { title: "控制器SN号", field: "aebsSn" },
      { title: "控制器PN号", field: "aebsPn" },
      { title: "前向一体机软件版本号", field: "aebCameraVersion" },
      { title: "前向一体机SN号", field: "aebCameraSn" },
      { title: "DMS相机软件版本号", field: "dmsCameraVersion" },
      { title: "记录仪版本号", field: "carDvrVersion" },
      { title: "左侧BSD相机软件版本号", field: "bsdLeftCameraVersion" },
      { title: "右侧BSD相机软件版本号", field: "bsdRightCameraVersion" },
      { title: "后向RVC相机软件版本号", field: "rvcCameraVersion" },
      { title: "前向毫米波雷达软件版本号", field: "aebRadarVersion" },
      { title: "左侧BSD角雷达软件版本号", field: "bsdLeftRadarVersion" },
      { title: "右侧BSD角雷达软件版本号", field: "bsdRightRadarVersion" },
      { title: "后向RVC毫米波雷达软件版本号", field: "rvcRadarVersion" },
      { title: "显示器软件版本号", field: "displayerSwVersion" },
      { title: "显示器SN号", field: "displayerSn" },
      { title: "4G设备软件版本号", field: "t4gVersion" },
      { title: "IMU软件版本号", field: "imuVersion" },
      { title: "执行机构软件版本号", field: "cableMotorVersion" },
      { title: "执行机构SN号", field: "cableMotorSn" },
      { title: "SIM卡ICCID", field: "iccid" },
    ],
  },
]
